import React, { useMemo, useRef, useState } from "react";

import type { ProseReact } from "~/lib/prose";

export const GlobalSearchContext = React.createContext<{
	/** The last search query the user visited this session */
	lastQuery: string | undefined;
	setLastQuery: (value: string) => void;
	/** If we're currently on the global search page, a ref to its GlobalSearchBar */
	globalSearchBarRef: React.RefObject<ProseReact> | null;
}>({
	lastQuery: undefined,
	setLastQuery: () => {
		throw new Error("Tried to save last search query, but couldn't find GlobalSearchContext");
	},
	globalSearchBarRef: null,
});

export const GlobalSearchContextProvider: React.FC<{}> = ({ children }) => {
	let [lastQuery, setLastQuery] = useState<string | undefined>(undefined);
	let globalSearchBarRef = useRef<ProseReact>(null);

	let contextValue = useMemo(
		() => ({
			lastQuery,
			setLastQuery,
			globalSearchBarRef,
		}),
		[lastQuery, globalSearchBarRef],
	);

	return <GlobalSearchContext.Provider value={contextValue}>{children}</GlobalSearchContext.Provider>;
};
